import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {
    getDeletedCardReaderDatas,
    hardDeleteCardReaderData,
    restoreCardReaderData,
} from "../../../redux/modules/CardReader/action";

class CardReaderTrash extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getDeletedCardReaderDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.cardReader.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const cardReaderColumn = [
            {
                name: "Card Reader",
                path: "name",
                show: true,
            },
            {
                name: "UNUM",
                path: "UNUM",
                show: true,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        path={this.props.location.pathname}
                        title={"CardReader Category Data"}
                        data={this.props.cardReader.datas}
                        columns={cardReaderColumn}
                        trashAction={true}
                        deleteAction={(id) => this.props.hardDeleteCardReaderData(id)}
                        restoreAction={(id) => this.props.restoreCardReaderData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    cardReader: state.cardReader,
});

const mapDispatchToProps = {
    getDeletedCardReaderDatas,
    hardDeleteCardReaderData,
    restoreCardReaderData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(CardReaderTrash)
);
